<template>
    <div>
      <client-title :title="title"></client-title>
      <div class="auth-control full-parent layout" v-if="hasPower">
        <org-tree :selectedList="authTableList" @toggleClick="toggleAuthor" :onlyComp="true"></org-tree>
        <div class="auth-main">
          <!-- 授权列表 -->
          <el-table
            width="100%"
            height="100%"
            header-row-class-name="md-table-header-row"
            :data="authTableList"
            ref="table"
            empty-text="请选择授权对象"
          >
            <el-table-column width="30" align="right">
              <template slot-scope="{ row }">
                <i class="el-icon-delete remove-row-btn" @click="removeRow(row)"></i>
              </template>
            </el-table-column>
            <el-table-column label="授权对象" align="left">
              <template slot-scope="{ row }">
                <auth-icon :row="row"></auth-icon>
              </template>
            </el-table-column>
            <template v-if="isData">
              <el-table-column label="权限" align="center" width="224px">
                <template slot-scope="{ row }">
                  <auth-btn :categoryId="categoryId" v-model="row.Power"></auth-btn>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column
                v-for="col in tableCols"
                :key="col.prop"
                :prop="col.prop"
                :label="col.label"
                :width="col.width"
                :min-width="col.minWidth"
                :align="col.hasOwnProperty('align') ? col.align : 'center'"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <md-indeterminate-check
                    v-if="col.component == 'checkbox'"
                    v-model="row.Power[col.prop]"
                    :three="!isData"
                    :disabled="col.disabled"
                  ></md-indeterminate-check>
                  <el-select
                    v-else-if="col.component=='select'"
                    v-model="row.Power[col.prop]"
                    size="mini"
                    placeholder="未设置"
                  >
                    <el-option
                      v-for="option in col.options"
                      :key="option.value"
                      :label="option.label"
                      :value="option.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </template>
            <el-table-column
              prop="ExpiryDate"
              label="有效期至"
              width="100"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="{ row,$index }">
                <span
                  class="expire-date"
                  @click="datePick($index)"
                >{{row.ExpiryDate == '2099-12-31' ? '永久' : row.ExpiryDate}}</span>
                <auth-date-picker v-model="row.ExpiryDate" :ref="'date'+$index" />
              </template>
            </el-table-column>
            <el-table-column width="4"></el-table-column>
          </el-table>
        </div>
        <div class="btns-wrap">
          <el-button type="info" size="medium" plain @click="closeWindow">取消</el-button>
          <el-button
            type="primary"
            size="medium "
            class="save-btn"
            :loading="saveBtnLoading"
            @click="submit"
          >保存</el-button>
        </div>
      </div>

      <span v-if="hasPower===false">{{ noPowerMsg }}</span>
    </div>
  </template>
  <script>
    import {WinForm} from '@digital-supply-chain/module'
    import {AuthService,Message} from '@/service';
    import {UtilService} from '@/libs'
    import mdIndeterminateCheck from "./md-indeterminate-check.vue";
    import AuthBtn from "./auth-btn.vue";
    import AuthIcon from "./auth-icon.vue";
    import AuthDatePicker from "./auth-datepicker.vue";
    import { AuthorityServer } from "./authority";

    import OrgTree from "./org-tree.vue";

    import ClientTitle from "@/components/client-title.vue"
  
    export default {
      data() {
        return {
          selectedList: [], // 已选择授权
          tableCols: [],
          isData: true,
          categoryId: Number(UtilService.getUrlParamObj().categoryId),
          saveBtnLoading: false,
          hasPower: null,
          noPowerMsg: "",
          authData: [],

          title: '修改“' + decodeURIComponent(UtilService.getUrlParamObj().auth_name) + '”授权',
        };
      },
      async created() {
        let multi_auth_datas = UtilService.getUrlParamObj().auth_datas;
        try {
          this.authData = JSON.parse(decodeURIComponent(multi_auth_datas))
        } catch (error) {}
        let powerParams = this.authData.map((item) => {
          const { CategoryID, DataID } = item;
          return { CategoryID, DataID, Key: "del" };
        });
        const powrers = await AuthorityServer.powerBatchAllow(powerParams);
        let allHasPower = powrers.every((item) => item.HasPower);
        if (!allHasPower) {
          if (this.authData.length === 1) {
            this.noPowerMsg =
              this.authData[0].DataID === 0
                ? "您无权限为其他人员授权！"
                : "您无权限将当前数据授权给其他人员！";
          } else {
            // 您无权限将当前数据（或其中部分数据）授权给其他人员！
            this.noPowerMsg = " 您无权限将其中部分数据授权给其他人员！";
          }
          this.hasPower = false;
        } else {
          this.hasPower = true;
          this.isData = this.authData.every((item) => Number(item.DataID) !== 0); // 多选是数据授权，dataId==0 是类目授权!；
          this.initControl();
        }
      },
      methods: {
        initControl() {
          this.tableCols.push(
            ...AuthService.getAuthCols(this.isData, this.categoryId)
          );
          // 只有单个授权的时候才加载已授权列表
          if (this.authData.length == 1) {
            AuthService.getAuthList(this.categoryId, this.authData[0].DataID).then(
              (res) => {
                this.selectedList = res;
              }
            );
          }
        },
        // 选择日期
        datePick(index) {
          this.$refs["date" + index].showPicker();
        },
        // 提交
        submit() {
          let res = this.getSaveData();
          if (!res) return;
          const { Datas, Powers } = res;
          // 保存授权
          AuthService.saveAuth({ Datas, Powers })
            .then((res) => {
              if (this.isData) {
                let authPowers = Powers.filter((item) => item.Power != null); // 去掉删除授权
                let key = UtilService.getUrlParamObj().emitKey || `toggleRowAuth_${this.categoryId}`;
                WinForm.md.$emit(key, { Datas, authedLen: authPowers.length });
              }
              Message.success("修改授权成功！");
              setTimeout(() => {
                this.saveBtnLoading = false;
                this.closeWindow();
              }, 1000);
            })
            .catch((err) => {
              this.saveBtnLoading = false;
            });
        },
        getSaveData() {
          // 序列化数据
          let Powers = [];
          let hasEmpty = false;
          this.selectedList.forEach((row) => {
            let power = Object.assign({}, row.Power);
            power.view = power.view === "" ? -1 : Number(power.view);
  
            let isAuth = false;
            for (const key in power) {
              if (power[key] == -1) {
                delete power[key]; // 默认权限（-1） 不传参
              } else {
                isAuth = true; // 只要有一个不等于-1的就可以保存
              }
            }
            let item = {
              BeCompID: row.CompID,
              BeOrgID: row.OrgID,
              BeUserID: row.UserID,
              ExpiryDate: row.ExpiryDate,
              Power: power,
            };
            if (row.hasOwnProperty("IsDelete")) {
              // 已授权 删除
              if (row.IsDelete || !isAuth) item.Power = null;
              Powers.push(item);
            } else {
              if (isAuth) Powers.push(item);
              else hasEmpty = true;
            }
          });
          if (hasEmpty) {
            Message.warning("授权对象的配置项不能为空");
            return false;
          }
          if (Powers.length == 0) {
            Message.warning("授权列表不能为空");
            return false;
          }
          this.saveBtnLoading = true;
          return { Datas: this.authData, Powers };
        },
        // 取消授权
        closeWindow() {
          window.close();
        },
        // 获取数据index；
        getSelectedIndex(data) {
          let index = this.selectedList.findIndex(
            (item) =>
              item.OrgID == data.OrgID &&
              item.UserID == data.UserID &&
              item.CompID == data.CompID
          );
          return index;
        },
        // tree/users 点击授权
        toggleAuthor(row) {
          let index = this.getSelectedIndex(row);
          if (index > -1) {
            let authrow = this.selectedList[index]; // row已经授过权 只改变IsDelete状态
            this.removeRow(authrow, index);
          } else {
            let data = Object.assign({}, row);
            data.Name = row.Phone
              ? `${row.Name}(${row.Phone.substr(-4)})`
              : row.Name;
            data.ExpiryDate = "2099-12-31";
            data.Power = {};
            // 更改默认选中;
            this.tableCols.forEach((item) => {
              if (item.prop !== "Name")
                data.Power[item.prop] =
                  item.default === undefined ? -1 : item.default;
            });
            this.selectedList.push(data);
          }
        },
        // 删除选中列表中的行
        removeRow(row, index) {
          if (row.hasOwnProperty("IsDelete")) {
            row.IsDelete = !row.IsDelete; // 删除授权
          } else {
            let rowIndex = index || this.getSelectedIndex(row);
            this.selectedList.splice(rowIndex, 1);
          }
        },
      },
      computed: {
        authTableList() {
          return this.selectedList.filter((item) => !item.IsDelete);
        },
      },
      components: {
        mdIndeterminateCheck,
        AuthIcon,
        OrgTree,
        AuthBtn,
        AuthDatePicker,
        ClientTitle,
      },
    };
  </script>
  
  <style lang="less" scoped>
    .auth-control {
      background: #FFF;
      padding-bottom: 50px;
      background-color: #fff;
      display: flex;
      top: 30px;
    }
  
    .auth-main {
      flex: 1;
      height: 100%;
      overflow: auto;
      background-color: #fff;
  
      .remove-row-btn {
        font-size: 12px;
        padding: 2px;
        cursor: pointer;
        &:hover {
          color: #F33;
        }
      }
      .expire-date {
        color: #3697ff;
        cursor: pointer;
      }
      .el-date-editor {
        width: 0px;
        height: 0px;
        overflow: hidden;
        position: absolute;
        left: 35px;
        top: 22px;
      }
    }
    .btns-wrap {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #fff;
      text-align: right;
      height: 50px;
      box-sizing: border-box;
      padding-top: 10px;
      padding-right: 20px;
      z-index: 100;
      border-top: 1px solid #e5e7ec;
  
      .el-button--medium {
        padding: 6px 20px;
      }
  
      .save-btn {
        width: 140px;
      }
    }
  
    /deep/ .auth-main {
      /deep/ .el-checkbox {
        vertical-align: middle;
      }

      // table样式
      .el-table th,
      .el-table td {
        padding: 6px 0;
      }

      .el-table::before {
        height: 0;
      }

      .el-table .cell {
        padding: 0 6px;
      }

      .el-table__header-wrapper {
        .has-gutter,
        .md-table-header-row {
          th {
            font-size: 14px;
            background-color: rgba(249, 249, 250, 1);
            color: #333333;
          }
        }
      }
    }
  </style>
  